"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ddActions = void 0;
exports.ddActions = {
    onboarding: {
        upload: {
            invalid: 'onboarding:upload:invalid',
            valid: 'onboarding:upload:valid',
            cancel: 'onboarding:upload:cancel',
            confirm: 'onboarding:upload:confirm',
            requirements: 'onboarding:upload:requirements',
            template: 'onboarding:upload:download-template',
            connect: 'onboarding:upload:connect-instead',
        },
    },
};
//# sourceMappingURL=analytics.js.map